export default function MundUTMify(props) {
  return (
    <svg
      width={88}
      height={56}
      viewBox="0 0 88 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3895_78405)">
        <rect
          x={3.50488}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.50488 13.8579)"
          fill="url(#paint0_linear_3895_78405)"
        />
        <g clipPath="url(#clip1_3895_78405)">
          <path
            d="M26.0782 15.3203L25.2322 16.5813C25.1136 16.7584 24.8855 16.8195 24.6942 16.7254L23.3277 16.0525C23.2183 15.9984 23.0886 15.9927 22.9776 16.0391C22.2987 16.3211 21.6254 16.6683 20.9644 17.079C17.4743 19.2486 15.2675 23.0549 15.1143 27.1759C14.8342 34.8438 20.5852 40.3951 27.1835 40.8292C28.543 40.9177 29.9398 40.7913 31.3277 40.4194C32.7157 40.0475 33.9886 39.4585 35.1217 38.7021C39.5809 35.7223 41.8726 30.0988 40.4028 24.6133C38.7155 18.3163 32.6423 14.3431 26.374 15.1314C26.2525 15.1473 26.1425 15.2149 26.0732 15.3193L26.0782 15.3203ZM18.1565 31.7825L18.1581 31.7797L21.9767 30.7565C22.1772 30.8672 22.294 30.9312 22.4923 31.0425C23.3437 33.6623 24.4822 35.8834 25.7497 37.5147C25.9995 37.8362 25.7041 38.2919 25.3113 38.1898C22.1249 37.3396 19.4058 35.0106 18.1527 31.7859L18.1565 31.7825ZM30.803 38.1601C30.7771 38.1694 30.7527 38.176 30.7284 38.1825C30.704 38.189 30.6797 38.1955 30.6525 38.2004C29.2126 38.4671 26.475 35.7236 24.736 30.4818C24.6595 30.2497 24.7941 29.9992 25.0287 29.9363L31.5413 28.1913C31.776 28.1284 32.0177 28.2781 32.0676 28.5173C33.1824 33.9263 32.1811 37.6717 30.803 38.1601ZM35.4211 35.4809C35.1348 35.7673 34.6505 35.5181 34.7039 35.1154C34.9992 32.9677 34.8453 30.3302 34.1989 27.4839C34.1983 27.4817 34.2005 27.4811 34.2005 27.4811L33.7102 25.6511C33.6494 25.4243 33.4162 25.289 33.1904 25.3495L18.0246 29.4132C17.7701 29.4814 17.5199 29.3006 17.4919 29.0364C17.1486 25.7896 18.3299 22.6275 20.5518 20.4092C20.8402 20.1222 21.323 20.3742 21.2679 20.7798C21.0627 22.2718 21.0753 24.001 21.3167 25.8762C21.3491 26.1297 21.6028 26.2976 21.8486 26.2318L23.2675 25.8516C23.4712 25.797 23.6027 25.5973 23.5773 25.3873C23.0534 21.0592 23.9675 18.157 25.1698 17.73L25.3182 17.6903C26.573 17.4589 28.8178 19.5146 30.526 23.5254C30.609 23.72 30.8205 23.8278 31.0264 23.7726L32.4431 23.393C32.6889 23.3271 32.8253 23.057 32.7259 22.8191C32.0025 21.0754 31.1465 19.5722 30.2244 18.3799C29.9745 18.0584 30.2682 17.596 30.6593 17.7009C33.8379 18.5484 36.5496 20.8675 37.807 24.0815C37.8118 24.0993 37.8188 24.1165 37.8235 24.1343L38.4104 26.3245C38.4152 26.3423 38.4199 26.3601 38.4225 26.3784C38.9405 29.7906 37.7495 33.1554 35.4205 35.4787L35.4211 35.4809Z"
            fill="url(#paint1_linear_3895_78405)"
          />
        </g>
      </g>
      <path
        d="M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z"
        fill="#0F111C"
      />
      <path
        d="M72.1606 26.0821L67.7412 18.4275L73.7782 20.0451L72.1606 26.0821Z"
        fill="url(#paint2_linear_3895_78405)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.8377 27.2895L66.5344 18.1039L62.6521 32.5928L55.4077 30.6516L54.4371 34.2739C53.9011 36.2743 55.0883 38.3306 57.0888 38.8666L64.3332 40.8078C66.3337 41.3438 68.39 40.1566 68.926 38.1561L71.8377 27.2895ZM51.8831 14.8254L49.2949 24.4846C48.6695 26.8185 50.0546 29.2175 52.3885 29.8429L55.407 30.6517L59.1275 16.7665C59.2169 16.4331 59.019 16.0904 58.6856 16.0011L52.6486 14.3834C52.3151 14.2941 51.9724 14.492 51.8831 14.8254Z"
        fill="url(#paint3_linear_3895_78405)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3895_78405"
          x1={23.5049}
          y1={13.8579}
          x2={23.5049}
          y2={53.8579}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29282C" />
          <stop offset={1} stopColor="#100F11" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3895_78405"
          x1={10.6936}
          y1={13.8571}
          x2={35.8057}
          y2={35.4543}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3895_78405"
          x1={73.94}
          y1={19.4414}
          x2={69.9509}
          y2={22.2548}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01E3FD" />
          <stop offset={1} stopColor="#0060EA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3895_78405"
          x1={53.0735}
          y1={9.71096}
          x2={62.6537}
          y2={37.0636}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <clipPath id="clip0_3895_78405">
          <rect
            x={3.50488}
            y={13.8579}
            width={40}
            height={40}
            rx={10}
            transform="rotate(-15 3.50488 13.8579)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_3895_78405">
          <rect
            width={30}
            height={30}
            fill="white"
            transform="translate(9.62891 17.3936) rotate(-15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
